import type { Feedback } from "@productlane/zero/schema"

interface ThreadNoteArg {
	origin: Feedback["origin"]
	createdAt?: Feedback["createdAt"]
	text?: Feedback["text"] | null
	threadMessages?: readonly unknown[] | null
}

/**
 * Whether `feedback.text` is the team's internal note on this thread rather
 * than something the customer wrote.
 */
export function isThreadNoteEditable(
	arg: Feedback["origin"] | ThreadNoteArg,
): boolean {
	const origin = typeof arg === "string" ? arg : arg.origin
	const createdAt = typeof arg === "string" ? undefined : arg.createdAt
	// An AI chat writes every turn as a thread message and leaves `text` empty,
	// so a promoted LIVE_CHAT thread with a body predates that: the body is the
	// customer's opening message and the note editor would overwrite it.
	const carriesCustomerBody =
		typeof arg === "string"
			? false
			: (arg.threadMessages?.length ?? 0) > 0 && !!arg.text?.trim()
	return (
		origin === "INAPP" ||
		(origin === "LIVE_CHAT" && !carriesCustomerBody) ||
		// TEMP legacy SLACK_CONNECT threads stored the first message in feedback.text — safe to remove ~6-12mo after 2026-03-02
		(origin === "SLACK_CONNECT" &&
			(!createdAt || new Date(createdAt) > new Date("2026-03-02T13:55:00Z")))
	)
}
